import { render, staticRenderFns } from "./ChevronRight.vue?vue&type=template&id=d2d65dee&functional=true&"
import script from "./ChevronRight.vue?vue&type=script&lang=js&"
export * from "./ChevronRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports